import Duck from 'extensible-duck'

const initialState = {
  productsVouchersList: [],
}

const types = ['UPDATE_PRODUCTS_VOUCHERS_LIST', 'RESET_PRODUCTS_VOUCHERS']

export default new Duck({
  namespace: 'content',
  store: 'productsVouchers',
  types,
  initialState,
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.UPDATE_PRODUCTS_VOUCHERS_LIST: {
        const incoming = action.payload
        const uniqueNewItems = incoming.filter(
          (newItem) =>
            !state.productsVouchersList.some(
              (existing) => existing.id_product === newItem.id_product,
            ),
        )

        return {
          ...state,
          productsVouchersList: [
            ...state.productsVouchersList,
            ...uniqueNewItems,
          ],
        }
      }
      case duck.types.RESET_PRODUCTS_VOUCHERS:
        return initialState
      default:
        return state
    }
  },
  creators: (duck) => ({
    updateProductsVouchersList: (payload) => ({
      type: duck.types.UPDATE_PRODUCTS_VOUCHERS_LIST,
      payload,
    }),
    resetProductsVouchers: () => ({ type: duck.types.RESET_PRODUCTS_VOUCHERS }),
  }),
})
